import axios from "axios";

export interface UploadFileToStorageProps {
  uploadUrl: string;
  buffer: File;
  contentType: string;
}

// Instancia plana sin auth — el SAS URL ya lleva la firma de Azure
const storageApi = axios.create();

export const uploadFileToStorage = async (params: UploadFileToStorageProps) => {
  const response = await storageApi.put(params.uploadUrl, params.buffer, {
    headers: {
      "Content-Type": params.contentType,
      "x-ms-blob-type": "BlockBlob",
    },
  });
  return response.data;
};
